import { API_ENDPOINTS } from 'services/api';
import httpClient from 'services/httpClient';

export interface UploadSharepointForm {
  sharepointToken: string;
  folderName: string;
  fileName: string;
  fileBase64: string;
}

export const sharepointService = {
  uploadFile: async (data: UploadSharepointForm) => {
    const response = await httpClient.post(API_ENDPOINTS.SHAREPOINT.UPLOAD, data);
    return response.data;
  },
  getTokenSharepoint: async () => {
    const response = await httpClient.get(API_ENDPOINTS.SHAREPOINT.GET_TOKEN);
    return response.data;
  }
};
